import React, { Fragment } from 'react';
interface SymbolProps {
  size?: number;
  className?: string;
}
export function GenogramDiagram({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-87">
      <circle cx="30" cy="30" r="10" data-id="element-88" />
      <rect x="60" y="20" width="20" height="20" data-id="element-89" />
      <line x1="40" y1="30" x2="60" y2="30" data-id="element-90" />
      <line x1="50" y1="30" x2="50" y2="60" data-id="element-91" />
      <circle cx="50" cy="70" r="10" data-id="element-92" />
    </svg>;
}
export function ConnectedSilhouettes({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-93">
      {/* Figure 1 */}
      <circle cx="30" cy="30" r="8" data-id="element-94" />
      <path d="M30 38 v25 M20 50 h20 M25 80 l5 -17 l5 17" data-id="element-95" />
      {/* Figure 2 */}
      <circle cx="70" cy="40" r="8" data-id="element-96" />
      <path d="M70 48 v25 M60 60 h20 M65 90 l5 -17 l5 17" data-id="element-97" />
      {/* Connection */}
      <line x1="40" y1="50" x2="60" y2="60" strokeDasharray="2 2" data-id="element-98" />
    </svg>;
}
export function ConstellationNodeMap({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-99">
      <circle cx="20" cy="20" r="4" data-id="element-100" />
      <circle cx="80" cy="30" r="4" data-id="element-101" />
      <circle cx="50" cy="50" r="4" data-id="element-102" />
      <circle cx="30" cy="80" r="4" data-id="element-103" />
      <circle cx="70" cy="70" r="4" data-id="element-104" />
      <line x1="24" y1="22" x2="46" y2="48" data-id="element-105" />
      <line x1="76" y1="32" x2="54" y2="48" data-id="element-106" />
      <line x1="48" y1="54" x2="32" y2="76" data-id="element-107" />
      <line x1="54" y1="52" x2="68" y2="68" data-id="element-108" />
    </svg>;
}
export function PegDollSymbol({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-109">
      <circle cx="50" cy="25" r="15" data-id="element-110" />
      <path d="M35 40 Q50 35 65 40 L75 90 Q50 95 25 90 Z" data-id="element-111" />
    </svg>;
}
export function ConcentricRings({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-112">
      <circle cx="50" cy="50" r="40" data-id="element-113" />
      <circle cx="50" cy="50" r="30" data-id="element-114" />
      <circle cx="50" cy="50" r="20" data-id="element-115" />
      <circle cx="50" cy="50" r="10" data-id="element-116" />
    </svg>;
}
export function FlowerOfLifeFragment({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-117">
      <circle cx="50" cy="30" r="25" data-id="element-118" />
      <circle cx="30" cy="60" r="25" data-id="element-119" />
      <circle cx="70" cy="60" r="25" data-id="element-120" />
    </svg>;
}
export function RelationalFlowArrow({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-121">
      <circle cx="20" cy="80" r="5" data-id="element-122" />
      <circle cx="80" cy="20" r="5" data-id="element-123" />
      <path d="M25 75 Q40 40 75 25" markerEnd="url(#arrowhead)" data-id="element-124" />
      <defs data-id="element-125">
        <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto" data-id="element-126">
          <polygon points="0 0, 10 3.5, 0 7" fill="currentColor" data-id="element-127" />
        </marker>
      </defs>
    </svg>;
}
export function SystemicTriad({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-128">
      <circle cx="50" cy="20" r="8" data-id="element-129" />
      <circle cx="20" cy="80" r="8" data-id="element-130" />
      <circle cx="80" cy="80" r="8" data-id="element-131" />
      <line x1="46" y1="28" x2="24" y2="72" data-id="element-132" />
      <line x1="54" y1="28" x2="76" y2="72" data-id="element-133" />
      <line x1="28" y1="80" x2="72" y2="80" data-id="element-134" />
    </svg>;
}
export const ALL_CONSTELLATION_SYMBOLS = [GenogramDiagram, ConnectedSilhouettes, ConstellationNodeMap, PegDollSymbol, ConcentricRings, FlowerOfLifeFragment, RelationalFlowArrow, SystemicTriad];